
import algoliaInsights from '~/mixins/algoliaInsights'
import ProductListAlgolia from '~/components/product-list/ProductListAlgolia.vue'
import ProductListCarousel from '~/components/product-list/ProductListCarousel/ProductListCarousel.vue'

export default {
  name: 'AlgoliaRecommendController',
  components: {
    ProductListAlgolia,
    ProductListCarousel,
  },
  mixins: [algoliaInsights],
  props: {
    recommendationType: {
      type: String,
      required: true,
    },
    objectId: {
      type: [String, Number],
      default: null,
    },
    facetName: {
      type: String,
      default: null,
      required: false,
    },
    childProps: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    isCarousel: {
      type: Boolean,
      default: false,
      required: false,
    },
    isInSearch: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  data: () => ({
    hits: [],
  }),
  watch: {
    hits (hits) {
      this.$emit('hits-update', hits.length)
    },
  },
  mounted () {
    if (
      ![
        'frequentlyBoughtTogether',
        'relatedProducts',
        'trendingItems',
        'trendingFacets', // needs implementation inside the entire facet list
      ].includes(this.recommendationType)
    ) {
      console.warn(
        `Invalid algolia recommendation type ${this.recommendationType}`
      )
    }

    this[this.recommendationType]({
      objectID: this.objectId,
      facetName: this.facetName,
    })
  },
  methods: {
    frequentlyBoughtTogether ({ objectID }) {
      return this.getAlgoliaRecommendClient()
        .getFrequentlyBoughtTogether([
          {
            indexName: this.indexName,
            objectID,
            maxRecommendations: 4
          },
        ])
        .then((response) => {
          this.hits = response?.results?.[0]?.hits ?? []
        }).catch(() => console.debug('Couldn\'t algoliaRecommend.getFrequentlyBoughtTogether'))
    },
    relatedProducts ({ objectID }) {
      return this.getAlgoliaRecommendClient()
        .getRelatedProducts([
          {
            indexName: this.indexName,
            objectID,
            maxRecommendations: 4
          },
        ])
        .then((response) => {
          this.hits = response?.results?.[0]?.hits ?? []
        }).catch(() => console.debug('Couldn\'t algoliaRecommend.getRelatedProducts'))
    },
    trendingItems () {
      return this.getAlgoliaRecommendClient()
        .getTrendingItems([
          {
            indexName: this.indexName,
            maxRecommendations: 4
          },
        ])
        .then((response) => {
          this.hits = response?.results?.[0]?.hits ?? []
        }).catch(() => console.debug('Couldn\'t algoliaRecommend.getTrendingItems'))
    },
  },
}
